// @core/api/endpoints/document/create_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateDocumentRequest,
  DocumentResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create document
 * Creates a new standalone controlled document. Auto-assigns a document number if a numbering scheme is configured for the category or type.
 */
export async function CreateDocument(
  data: CreateDocumentRequest,
  options?: RequestOptions
): Promise<DocumentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/documents`;
  const requestOptions = options;
  return client.post<DocumentResponse>(requestPath, data, requestOptions);
}
